import { getParsed, SESSION_KEYS, setParsed } from '@/services/browserStorage'
import { PAGE_PATHS } from '@/services/paths'
import { usePathname } from 'next/navigation'
import { useRouter } from 'next/router'
import { createContext, useContext, useEffect } from 'react'

interface HistoryContextType {
  getHistory: () => Array<string>
}

export const HistoryContext = createContext<HistoryContextType>(
  {} as HistoryContextType
)

interface HistoryProviderProps {
  children: React.ReactNode
}

export function HistoryProvider({ children }: HistoryProviderProps) {
  const pathname = usePathname()
  const router = useRouter()

  useEffect(() => {
    const history = getParsed<Array<string>>(
      sessionStorage,
      SESSION_KEYS.history,
      []
    )

    const path = pathname === PAGE_PATHS.search ? router.asPath : pathname

    if (path === history[history.length - 1]) return

    const pathIndex = history.indexOf(path)

    if (pathIndex !== -1) {
      history.splice(pathIndex, 1)
    }

    history.push(path)

    setParsed(sessionStorage, SESSION_KEYS.history, history)
  }, [pathname, router.asPath])

  const getHistory = () => {
    return getParsed<Array<string>>(sessionStorage, SESSION_KEYS.history, [])
  }

  return (
    <HistoryContext.Provider value={{ getHistory }}>
      {children}
    </HistoryContext.Provider>
  )
}

export function useHistory() {
  return useContext(HistoryContext)
}
